export default __webpack_public_path__ + "static/media/gbr.e6c4646a.svg";